<template>
	<div>
		<div class="row">
			<div class="col-12">
				<InputText id="password" name="Password" type="password" :form="values" :errors="errors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<InputText id="password_confirm" name="Confirm Password" type="password" :form="values" :errors="errors" v-on:enter-pressed="setPassword"/>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center">
				<button class="button-action" @click="setPassword">Set Password</button>
			</div>
		</div>
	</div>
</template>

<script>
import passwordValidator from 'password-validator'
import auth from '../../lib/auth'
import InputText from '../Form/InputText.vue'
import InputSelect from '../Form/InputSelect.vue'

export default {
	components: {
		InputText
	},
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['password', 'password_confirm'],
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})
			
			if(validForm) {
				if(this.values.password != this.values.password_confirm) {
					this.errors['password_confirm'] = 'Passwords must match.'
					validForm = false
				} else {
					let passwordSchema = new passwordValidator()

					passwordSchema
						.is().min(8)
						.has().uppercase()
						.has().lowercase()
						.has().digits()
						.has().not().spaces()

					if(passwordSchema.validate(this.values.password) == false) {
						this.errors['password_confirm'] = 'Password must must be at least 8 characters long and contain a uppercase letter, a lowercase lettera and a number with no spaces.'
						validForm = false
					}
				}
			}

			return validForm
		},
		setPassword() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			this.$store.commit('app/setLoading', true)
			auth.setPassword(this.$route.query.token, this.values.password)
			.then(response => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: 'Your password has been reset, enter your new password below to login'
				})
				this.$router.push({ path: '/login' })
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		auth.checkResetToken(this.$route.query.token)
		.then(response => {
			this.$store.commit('app/setLoading', false);
		})
		.catch(err => {
			this.$store.commit('app/setLoading', false)
			this.$store.dispatch('app/addAlert', {
				type: 'error',
				message: 'Password token is invalid or has expired, please click \'lost password\' to set a new password'
			})
			this.$router.push({ path: '/login' })
		})
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/SetPassword/Form.vue